// INFO navigator.clipboard requires either localhost or secure connection (https)
export const copyToClipboard = async (value: string) => {
  try {
    await navigator.clipboard.writeText(value);
  } catch (error) {
    console.log(error); // eslint-disable-line
  }
};
